export default {
  Divider: {
    baseStyle: {
      borderColor: 'border.base',
    },
    sizes: {},
    variants: {
      tableFilter: {
        bgColor: 'gray.900',
        h: '2px',
      },
    },
    defaultProps: {},
  },
};
